module.exports = __webpack_public_path__ + "img/DCIImg04.070f5ba4.png";